import { render, staticRenderFns } from "./historyRemark.vue?vue&type=template&id=489d3127&scoped=true&"
import script from "./historyRemark.vue?vue&type=script&lang=js&"
export * from "./historyRemark.vue?vue&type=script&lang=js&"
import style0 from "./historyRemark.vue?vue&type=style&index=0&id=489d3127&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d3127",
  null
  
)

export default component.exports